import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(() => ({
  heightsForm: {
    height: '75px',
  },
}))
export default useStyles
